export const CHECKOUT_MAX_TICKETS = 20;